const scriptLoaded = src => document.querySelector(`script[src="${src}"]`)

const loadScriptPromise = <T = unknown>(
  src: string,
  name: string,
): Promise<T | null> =>
  new Promise((resolve, reject) => {
    if (typeof window === 'undefined') {
      resolve(null)
      return
    }
    if (scriptLoaded(src)) {
      resolve((window as unknown as Record<string, T>)[name] ?? null)
      return
    }
    const el = document.createElement('script')
    el.async = true
    el.src = src
    el.onload = () => {
      el.onerror = el.onload = null
      resolve((window as unknown as Record<string, T>)[name] ?? null)
    }
    el.onerror = () => {
      el.onerror = el.onload = null
      reject(new Error(`Failed to load ${src}`))
    }
    document.head.appendChild(el)
  })

export default loadScriptPromise
